import React, { useEffect, useMemo, useState } from "react";
import './LedgerList.css'
import { Edit, Trash } from "lucide-react";
import axios from "axios";
import toast from "react-hot-toast";
import { getBranches } from "../redux/slices/branchSlice";
import { useDispatch, useSelector } from "react-redux";

const LedgerList = () => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [groups,setGroups]=useState([]);
  const [selectedGroup,setSelectedGroup]=useState(null);
  const [branch,setBranch]=useState([]);
  const [selectedBranch,setSelectedBranch]=useState(null);

  const superAdminId = localStorage.getItem("adminuserId");
  const rowsPerPage = 5;
  


 

  // Dynamic State Data
  const [ledgers, setLedgers] = useState([]);


  const fetchLedgers = async (page = currentPage) => {
      // console.log(superAdminId);
      try {
        const res = await axios.get(
          `https://payyug.in/api/ledger/getall`,{
            params: {
              superAdminId,
              page,
              limit: rowsPerPage,
            }
          }
        );
  
        // console.log("response ledgers data", res);
      
        setLedgers(res.data.rows || []);
        setTotalPages(res.data.totalPages || 1);
        // setCurrentPage(res.data.currentPage || page);
      } catch (err) {
        console.error("Fetch Error:", err);
      }
   };

  const fetchGroups = async () => { 
    // console.log(superAdminId);
    try {
      const res = await axios.get(
        `https://payyug.in/api/ledger-group/get-all?superAdminId=${superAdminId || 14}`
      );

      console.log("response data", res);
      setGroups(res.data.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };
  
   const fetchBranchs = async () => { 
    // console.log(superAdminId);
    try {
      const res = await axios.get(
        `https://payyug.in/api/get-branch`,{
        params: { 
          SuperAdminId:superAdminId,
          limit:"all"
        },}
      );

      console.log("branch data", res);
      setBranch(res.data.branches || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
   };


  const createUpdate = async (e) => {
    e.preventDefault();
    console.log("formdata values are", formData);

    const payload = {
      name: formData.name,
      alias: formData.alias,
      group_id: selectedGroup?.id || Number(formData.group),
      openingBalance: Number(formData.openingBalance),
      superAdminId: Number(superAdminId),
      branchId: selectedBranch?.id || Number(formData.branch),
      ...(editIndex !== null ? { id: Number(editIndex) } : {}),
    };

    try {
      if (editIndex !== null) {
        // ===================== UPDATE ======================
        const updateUrl = `https://payyug.in/api/ledger/update`;

        try {
          await axios.put(updateUrl, payload);
        } catch (updateError) {
          if (updateError?.response?.status === 404) {
            console.warn("Update 404 fallback, retrying with URL id", updateError.response?.data);
            await axios.put(`https://payyug.in/api/ledger/update/${editIndex}`, payload);
          } else {
            throw updateError;
          }
        }

        toast.success("Ledger updated successfully");
      } else {
        // ===================== CREATE ======================
        await axios.post(`https://payyug.in/api/ledger/create`, payload);
        toast.success("Ledger created successfully");
      }

      await fetchLedgers();
      setModalOpen(false);
    } catch (error) {
      console.error("API Error:", error);

      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to save";

      toast.error(message);
    }
  };

  const handledelete = (id) => async () => {
      const confirmDelete = window.confirm("Are you sure you want to delete this center?");
      if (!confirmDelete) return;

      try {
        await axios.delete(`https://payyug.in/api/ledger/delete/${id}`);
        toast.success("Center deleted successfully");
        fetchLedgers();
      } catch (error) {
        toast.error("Failed to delete center");
      }
   };

  useEffect(()=> {
      fetchLedgers();
   },[currentPage]);
  

  useEffect(()=> {
     fetchGroups();
     fetchBranchs()
  },[])

  // Form Data
  const [formData, setFormData] = useState({
    name: "",
    alias: "",
    group: "",
    branch: "",
    openingBalance:""
  });

  // Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Create/Update Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.alias || !formData.group || !formData.branch || !formData.openingBalance ) {
      alert("Please fill all fields");
      return;
    }

    if (editIndex !== null) {
      const updated = [...ledgers];
      updated[editIndex] = { ...updated[editIndex], ...formData };
      setLedgers(updated);
      setEditIndex(null);
    } else {
      setLedgers([
        ...ledgers,
        { id: ledgers.length + 1, ...formData },
      ]);
    }

    setFormData({ name: "", alias: "",group:"", branch: "",openingBalance:"" });
    setModalOpen(false);
  };

  // Edit Handler
  const handleEdit = (index) => {
    setEditIndex(index.id);
    setFormData({
      name: index.name,
      alias: index.alias,
      group: index.group_id,
      branch: index.branchId,
      openingBalance: index.openingBalance
    });

    const foundGroup = groups.find((g) => g.id === index.group_id);
    const foundBranch = branch.find((b) => b.id === index.branchId);
    setSelectedGroup(foundGroup || null);
    setSelectedBranch(foundBranch || null);

    setModalOpen(true);
  };

  // Search + Pagination
  const filteredData = useMemo(() => {
    let data = [...ledgers];

    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    // if (searchQuery.trim()) {
    //   data = data.filter((item) =>
    // item.group.toLowerCase().includes(searchQuery.toLowerCase()) ||
    // item.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
    // item.status.toLowerCase().includes(searchQuery.toLowerCase())
    //   );
    // }

    return data;
  }, [ledgers, searchQuery]);

  // const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData;
  // .slice(
  //   (currentPage - 1) * rowsPerPage,
  //   currentPage * rowsPerPage
  // );

  return (
    <>
      <div className="account-ledger-list-container">
        <h2 className="heading">Ledger List</h2>

        <div className="account-ledger-list-top-section">
          <input
            type="text"
            placeholder="Search by Group / Type / Status..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <button
            className="add-btn"
            onClick={() => {
              setFormData({ name: "", alias: "",group:"", branch: "",openingBalance:"" });
              setEditIndex(null);
              setModalOpen(true);
            }}
          >
            Add New
          </button>
        </div>

        {/* Table */}
        <div className="account-ledger-list-report-section">
          <table className="account-ledger-list-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Ledger Name</th>
                <th>Alias</th>
                <th>Group ID</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

           <tbody>
            {paginatedData.length > 0 ? (
              paginatedData
                .map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.alias}</td>
                    <td>{item.group_id}</td>
                    <td>{item.status}</td>
                    <td>
                      <button
                        onClick={() =>
                          // (currentPage - 1) * rowsPerPage + index
                          handleEdit(item)
                        }
                      >
                        <Edit size={18} />
                      </button>
                      <Trash
                        className="delete-icon-gl"
                        onClick={ handledelete(item.id)}
                      />
                    </td>
                  </tr>
                ))
             ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No  records found
                </td>
                </tr>
              )}
           </tbody>


          </table>
        </div>

         {/* Pagination */}
         <div className="account-ledger-list-pagination-section">
            <div className="account-ledger-list-pagination-div">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                ⬅ Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next ➡
              </button>
            </div>
         </div>
         
        {/* Modal */}
        {modalOpen && (
          <div className="dialog-overlay">
            <div className="dialog-box">
              <h2 className="dialog-box-heading">
                {editIndex !== null ? "Edit Ledger" : "Add New Ledger"}
              </h2>

              <form className="dialog-box-form-section" onSubmit={createUpdate}>
                <div className="dialog-box-input-group">
                  <label>Ledger Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="dialog-box-input-group">
                  <label>Alias</label>
                  <input
                    type="text"
                    name="alias"
                    value={formData.alias}
                    onChange={handleChange}
                  />
                </div>

                <div className="dialog-box-input-group">
                  <label>Opening Balance</label>
                  <input
                    type="text"
                    name="openingBalance"
                    value={formData.openingBalance}
                    onChange={handleChange}
                  />
                </div>



                <div className="dialog-box-input-group">
                  <label>Group</label>
                  <select
                    name="group"
                    value={formData.group}
                    disabled={editIndex !== null}
                    onChange={(e) => {
                      handleChange(e);
                      const group = groups.find(
                        (c) => c.id === Number(e.target.value)
                      );
                      setSelectedGroup(group);
                    }}
                  >
                    <option value="">Select Group</option>
                    {groups.map((gn) => (
                      <option key={gn.id} value={gn.id}>
                        {gn.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="dialog-box-input-group">
                  <label>Select Branch</label>
                  <select
                    name="branch"
                    value={formData.branch}
                    disabled={editIndex !== null}
                    onChange={(e) => {
                      handleChange(e);
                      const group = branch.find(
                        (c) => c.id === Number(e.target.value)
                      );
                      setSelectedBranch(group);
                    }}
                  >
                    <option value="">Select Branch</option>
                    {branch.map((br) => (
                      <option key={br.id} value={br.id}>
                        {br.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="dialog-btns">
                  <button type="submit">
                    {editIndex !== null ? "Update" : "Create"}
                  </button>

                  <button type="button" onClick={() => setModalOpen(false)}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LedgerList

